import router from './router';
import container from './container';
import apiContainer from '../services/api';
import QueriesController from './services/queriesController.service';
import CommandsController from './services/commandsController.service';
import Paths from './services/paths';
import { acceptOrRejectItemChecklist } from './services'

const QueriesControllerFactory = () =>
  new QueriesController(apiContainer.apiController(), Paths);

const CommandsControllerFactory = () =>
  new CommandsController(apiContainer.apiController(), Paths);

container.queriesController = QueriesControllerFactory;
container.commandsController = CommandsControllerFactory;

Object.freeze(container);

export { router, acceptOrRejectItemChecklist };
